import { render, staticRenderFns } from "./ActionDispatcher.vue?vue&type=template&id=0527692a&scoped=true&"
import script from "./ActionDispatcher.vue?vue&type=script&lang=js&"
export * from "./ActionDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./ActionDispatcher.vue?vue&type=style&index=0&id=0527692a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527692a",
  null
  
)

export default component.exports